import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { darken } from '@material-ui/core/styles/colorManipulator';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import React, { useState } from 'react';
import ChipContainer from '../../../common/ChipContainer';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    panel: {
      padding: 24,
      backgroundColor: theme.palette.background.paper,
      boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)'
    },
    secondaryPanel: {
      display: 'flex',
      padding: 16,
      backgroundColor: darken(theme.palette.background.default, 0.02)
    },
    description: { 
      marginBottom: 16 
    },
    addUserTextField: { 
      flex: 1, 
      marginRight: 16 
    },
    chips: { 
      marginTop: 16 
    }
  })
);

interface Props {
  notifiers: any;
  onWorkflowNotifiersChange: (notifiers) => void;
}

function WorkflowNotificationsEditor(props: Props) {
  const { notifiers, onWorkflowNotifiersChange } = props;
  const [userToAdd, setUserToAdd] = useState('');

  const classes = useStyles({});

  const onAddUser = () => {
    if (!notifiers.includes(userToAdd)) {
      const notifiersCopy = notifiers.slice();
      notifiersCopy.push(userToAdd);
      onWorkflowNotifiersChange(notifiersCopy);
    }
    setUserToAdd('');
  };

  const onRemoveUser = (user: string) => {
    const notifiersCopy = notifiers.slice();
    notifiersCopy.splice(notifiersCopy.indexOf(user), 1);
    onWorkflowNotifiersChange(notifiersCopy);
  };

  return (
    <div className={classes.panel}>
      <Typography variant="caption" display="block" className={classes.description}>Workflow notification emails will be sent out upon workflow completion</Typography>
      <div className={classes.secondaryPanel}>
        <TextField
          className={classes.addUserTextField}
          placeholder="Add user email"
          value={userToAdd}
          onChange={(event) => setUserToAdd(event.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <Button variant="outlined" disabled={!userToAdd} color={userToAdd ? 'primary' : 'default'} onClick={onAddUser}>Add User</Button>
      </div>

      {notifiers.length > 0 && <div className={classes.chips}>
        <ChipContainer>
          {notifiers.map(email => <Chip key={email} label={email} variant="outlined" color="primary" onDelete={() => onRemoveUser(email)} />)}
        </ChipContainer>
      </div>}
    </div>);
};

export default WorkflowNotificationsEditor;
